import itemTypeToEmoji from 'util/itemTypeToEmoji';

const allVisibleAscii =
    ' !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~';

const getAllLetters = (items) => {
    const ownedLetters = items
        .filter(item => item.itemType.startsWith('COMMON_LETTER_') && item.hasUserItem())
        .map(item => itemTypeToEmoji[item.itemType].emoji).join('')
        .toLowerCase();
    return getAllAllowedLettersFromAllLetters(ownedLetters);
};

const getAllEmojis = (items) => {
    return items
        .filter(item => !item.itemType.startsWith('COMMON_LETTER_') && item.hasUserItem())
        .flatMap(item => itemTypeToEmoji[item.itemType].emoji);
};

const getAllAllowedLettersFromAllLetters = (allLetters) => {
    if (allLetters.length >= 26) {
        return allVisibleAscii;
    }

    let allowedLetters = [];
    allowedLetters.push(allLetters);
    if (allLetters.length >= 5) {
        allowedLetters.push(' ');
    }
    if (allLetters.length >= 10) {
        allowedLetters.push(allLetters.toUpperCase());
    }
    if (allLetters.length >= 15) {
        allowedLetters.push('.,!?-');
    }
    if (allLetters.length >= 20) {
        allowedLetters.push('1234567890');
    }
    return allowedLetters.join('');
};

export {getAllLetters, getAllEmojis};